// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3fi0l","rootCenter":"LoadMoreObserver_rootCenter__2zn0T","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__z6tp0"};